// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__accountNumber___c7ImV {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  padding: 2px 4px;
}

.styles__balanceWrapper___PDUDh {
  width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
  text-align: right;
}

.styles__balanceWrapper___PDUDh:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__balanceWrapper___PDUDh:last-child {
  margin-right: 0;
}

.styles__balanceWrapper___PDUDh:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.styles__balanceWrapper___PDUDh:nth-child(1n + 1) {
  clear: both;
}

.styles__boxLabel___wYdQe {
  line-height: 26px;
  margin: 0;
}

.styles__contentContainer___HQByB {
  display: flex;
  flex-direction: column;
}

.styles__trustInputContainer___AiMrc {
  padding-bottom: 0;
}

.styles__nameWrapper___d87gQ {
  width: calc(99.9% * 3/5 - (30px - 30px * 3/5));
}

.styles__nameWrapper___d87gQ:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__nameWrapper___d87gQ:last-child {
  margin-right: 0;
}

.styles__nameWrapper___d87gQ:nth-child(5n) {
  margin-right: 0;
  float: right;
}

.styles__nameWrapper___d87gQ:nth-child(5n + 1) {
  clear: both;
}

.styles__nameWrapper___d87gQ .styles__boxLabel___wYdQe {
    margin-right: 20px;
  }

.styles__section___W4rlN {
}

.styles__sectionSmall___d5esv {
}

.styles__title___u5bb1 {
  font-size: 28px;
}

.styles__titleName___BNOyO {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  margin-top: -5px;
}

.styles__row___NDXsa {
}

.styles__titleBox___BGbBL {
  margin-bottom: 20px;
  position: relative;
}

.styles__transactionWrapper___BPf5r {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/GPTMaster/styles.css"],"names":[],"mappings":"AAIA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8CAAkB;EAClB,iBAAiB;AACnB;;AAHA;EACE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AAEpB;;AAHA;EACE,eAAkB;AAEpB;;AAHA;EACE,eAAkB;EAAlB,YAAkB;AAEpB;;AAHA;EACE,WAAkB;AAEpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;AAEA;;AAEA;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtGPT from colors;\n\n.accountNumber {\n  background: gtGPT;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  padding: 2px 4px;\n}\n\n.balanceWrapper {\n  lost-column: 2/5 1;\n  text-align: right;\n}\n\n.boxLabel {\n  line-height: 26px;\n  margin: 0;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  display: flex;\n  flex-direction: column;\n}\n\n.trustInputContainer {\n  composes: contentContainer;\n  padding-bottom: 0;\n}\n\n.nameWrapper {\n  lost-column: 3/5;\n\n  .boxLabel {\n    margin-right: 20px;\n  }\n}\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.title {\n  font-size: 28px;\n}\n\n.titleName {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5px;\n  margin-top: -5px;\n}\n\n.row {\n  composes: row from helpers;\n}\n\n.titleBox {\n  composes: sectionSmall row;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.transactionWrapper {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"accountNumber": `styles__accountNumber___c7ImV`,
	"balanceWrapper": `styles__balanceWrapper___PDUDh`,
	"boxLabel": `styles__boxLabel___wYdQe`,
	"contentContainer": `styles__contentContainer___HQByB ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"trustInputContainer": `styles__trustInputContainer___AiMrc styles__contentContainer___HQByB ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"nameWrapper": `styles__nameWrapper___d87gQ`,
	"section": `styles__section___W4rlN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionSmall": `styles__sectionSmall___d5esv ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"title": `styles__title___u5bb1`,
	"titleName": `styles__titleName___BNOyO`,
	"row": `styles__row___NDXsa ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"titleBox": `styles__titleBox___BGbBL styles__sectionSmall___d5esv ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]} styles__row___NDXsa ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"transactionWrapper": `styles__transactionWrapper___BPf5r`
};
export default ___CSS_LOADER_EXPORT___;
